var _path, _path2, _path3, _path4, _polygon, _path5, _polygon2, _path6, _path7, _path8, _circle, _path9, _polygon3, _path10, _polygon4, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 922.43055,
    height: 543.51482,
    viewBox: "0 0 922.43055 543.51482",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M429.40405,719.95523c-.05566-.24511-5.43994-24.79785,5.55615-45.19043,10.9961-20.39166,34.46827-29.38476,34.70411-29.47363l1.07275-.40234.25342,1.11816c.05566.24512,5.43994,24.79785-5.55615,45.19043-10.99561,20.39166-34.46827,29.38477-34.70411,29.47363l-1.07324.40235Zm39.86182-72.33782c-4.70166,2.02246-23.25781,10.874-32.54492,28.09667-9.28809,17.22461-6.48584,37.59375-5.59229,42.63086,4.69971-2.01757,23.24854-10.85546,32.54492-28.09668C472.96118,673.02457,470.15991,652.65738,469.26587,647.61741Z",
    transform: "translate(-138.78472 -178.24259)",
    fill: "#f1f1f1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M457.03116,684.04435c-19.76056,11.88861-27.371,35.50268-27.371,35.50268s24.42779,4.33881,44.18835-7.5498,27.371-35.50269,27.371-35.50269S476.79172,672.15574,457.03116,684.04435Z",
    transform: "translate(-138.78472 -178.24259)",
    fill: "#f1f1f1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M403.38208,533.755h55.82731V505.49264H403.38208Z",
    transform: "translate(-138.78472 -178.24259)",
    fill: "#facc15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M415.04913,508.29308a7.93668,7.93668,0,0,0-8.31091-8.89017L398.88446,483.055l-11.09864,2.34969,11.41528,22.93065a7.97965,7.97965,0,0,0,15.848-.04225Z",
    transform: "translate(-138.78472 -178.24259)",
    fill: "#ffb7b7"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "105.767 519.858 115.004 524.585 137.634 491.205 124 484.228 105.767 519.858",
    fill: "#ffb7b7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M243.73878,693.879l18.19172,9.3096.00074.00038a13.02378,13.02378,0,0,1,5.65977,17.526l-.19281.37672-29.785-15.24261Z",
    transform: "translate(-138.78472 -178.24259)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "212.454 532.791 222.83 532.79 227.767 492.766 212.452 492.766 212.454 532.791",
    fill: "#ffb7b7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M348.59142,707.64523l20.43546-.00083h.00082a13.02377,13.02377,0,0,1,13.02307,13.02286v.4232l-33.45873.00124Z",
    transform: "translate(-138.78472 -178.24259)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M302.70032,384.56392s-6.94873-5.32368-6.94873,7.68016l-1.09716,42.97236,12.25169,40.59517,7.13159-13.166-2.92578-28.52633Z",
    transform: "translate(-138.78472 -178.24259)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M377.03136,502.10087s8.05774,39.24119-2.14873,71.4453L369.24221,697.3668l-20.68154-1.61155-7.252-91.85825-6.98338-45.66053L319.8214,599.86813l-47.80927,88.098-22.02449-17.18985s24.40667-66.59522,42.43744-80.57741l9.043-102.99572Z",
    transform: "translate(-138.78472 -178.24259)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 213.7317,
    cy: 130.27454,
    r: 23.5814,
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M350.84761,313.51884c2.82683.3678,4.95918-2.52447,5.94818-5.19806s1.74257-5.7862,4.2003-7.23041c3.35778-1.9731,7.65389.4,11.49368-.251,4.33631-.73516,7.15572-5.3308,7.37669-9.72343s-1.5271-8.61741-3.24227-12.66737l-.5988,5.03318a9.98113,9.98113,0,0,0-4.36168-8.72436l.77179,7.38543a7.83853,7.83853,0,0,0-9.01785-6.48609l.12154,4.40051c-5.00844-.59556-10.06064-1.19195-15.08391-.73823s-10.08162,2.043-13.88883,5.35126c-5.695,4.94857-7.77493,13.097-7.07665,20.6092s3.79932,14.56944,7.0313,21.38674c.81317,1.71525,1.9379,3.65079,3.82353,3.86929a3.85158,3.85158,0,0,0,3.7712-2.84219,10.30188,10.30188,0,0,0-.04573-5.06077c-.4765-2.5321-1.07717-5.12024-.62916-7.65754s2.27332-5.04462,4.831-5.35557,5.1749,2.61264,3.94519,4.8768Z",
    transform: "translate(-138.78472 -178.24259)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "239.706 334.352 160.991 329.274 166.915 304.729 238.859 320.81 239.706 334.352",
    fill: "#cbcbcb"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M329.94662,340.67725l4.93725-6.85464s5.51849,1.8754,20.29759,9.23183l1.04414,6.42222,25.65358,157.78706-46.62958-2.01147-12.69811-.27017-4.15546-9.315-5.12418,9.11755-12.40014-.26383-12.61742-7.31445,12.43455-38.03511,4.02295-34.74361-6.21728-32.73214s-7.82347-30.05728,22.30906-46.26386Z",
    transform: "translate(-138.78472 -178.24259)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "255.787 321.656 257.48 327.581 269.329 319.864 264.858 314.745 255.787 321.656",
    fill: "#cbcbcb"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M338.76693,359.748s18.36836-23.45,29.47029,2.68606l3.50019,27.38928s13.44915,34.04483,13.85365,47.81926c0,0,9.11826,17.97712,9.0345,27.41942l13.48858,30.53718-13.8346,8.58887L355.991,445.481Z",
    transform: "translate(-138.78472 -178.24259)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M520.78472,721.75741h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-138.78472 -178.24259)",
    fill: "#cbcbcb"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M597.358,414.94225h460.06211V182.03786H597.358Z",
    transform: "translate(-138.78472 -178.24259)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.21528,418.73745H593.5628V178.24259h467.65248ZM601.153,411.14723h452.472V185.83281H601.153Z",
    transform: "translate(-138.78472 -178.24259)",
    fill: "#e5e5e5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 739.86245,
    y: 46.21081,
    width: 86.67858,
    height: 148.0759,
    fill: "#e5e5e5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 550.66766,
    y: 46.20822,
    width: 174.83378,
    height: 40.75957,
    fill: "#facc15"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 550.66766,
    y: 98.31856,
    width: 174.83378,
    height: 43.85523,
    fill: "#e5e5e5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 550.66766,
    y: 153.52456,
    width: 174.83378,
    height: 40.75957,
    fill: "#e5e5e5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.63b912e5b8b203bbd7dff45dc300d876.svg";
export { ForwardRef as ReactComponent };